<template>
  <div>
    <!-- <h2>Подтвердите, что вы человек</h2> -->
    <div class="title-text">{{title}}</div>
    
    <!-- Кликаем по контейнеру wrapper -->
    <div class="wrapper" id="captcha-wrapper" @click="captchaImgClick">
      <img id="captcha-img" :src="captchaImg" alt="Загрузка капчи...">
    </div>

    <div class="controls">
      <button class="btn-renew" id="renew-btn" title="Обновить капчу" @click="renewCaptchaClick">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"/>
        </svg>
      </button>
      <button
        class="btn-submit"
        id="submit-btn"
        v-if="!disabled"
        :disabled="!userClicks.length"
        @click="submit">Проверить</button>
    </div>

    <div id="status-message"></div>
  </div>
</template>

<script>
export default {
  name: 'ClickableCaptcha',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    captchaId: {
      type: String,
      default: ''
    },
    captchaImageBase64: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userClicks: []
    }
  },
  computed: {
    captchaImg() {
      return this.captchaImageBase64.startsWith("data:image")
        ? this.captchaImageBase64
        : `data:image/png;base64,${this.captchaImageBase64}`;
    }
  },
  methods: {
    captchaImgClick(e) {
      if (!this.captchaId) return;
      if (this.disabled) return;
      if (this.userClicks.length > 9) return;
      // Координаты клика строго внутри контейнера
      const clickX = e.offsetX;
      const clickY = e.offsetY;

      const captchaImg = document.getElementById("captcha-img");
      const captchaWrapper = document.getElementById("captcha-wrapper");

      // Масштабируем координаты к оригинальному битмапу бэкенда
      const scaleX = captchaImg.naturalWidth / captchaWrapper.clientWidth;
      const scaleY = captchaImg.naturalHeight / captchaWrapper.clientHeight;

      const originalX = Math.round(clickX * scaleX);
      const originalY = Math.round(clickY * scaleY);

      // Добавляем координаты в массив
      this.userClicks.push({ x: originalX, y: originalY });

      // Отрисовываем кружочек на месте клика
      const marker = document.createElement("div");
      marker.className = "click-marker";
      marker.innerText = this.userClicks.length;
      marker.style.left = `${clickX}px`;
      marker.style.top = `${clickY}px`;
      captchaWrapper.appendChild(marker);
    },
    clearClicks() {
      this.userClicks = [];
      const markers = document.querySelectorAll(".click-marker");
      markers.forEach(m => m.remove());
    },
    renewCaptchaClick() {
      this.clearClicks();
      this.$emit('renew');
    },
    submit() {
      const payload = {
        captchaId: this.captchaId,
        value: JSON.stringify(this.userClicks) // Сериализуем массив координат в строку JSON
      };
      this.$emit('input', payload);
    }
  }
}
</script>

<style scoped>
.captcha-container {
  background: #ffffff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  width: 520px;
  text-align: center;
}
.title-text {
  margin-top: 0;
  /* color: #333333; */
  font-size: 20px;
  margin-bottom: 20px;
}
.wrapper {
  position: relative;
  display: inline-block;
  background: #eee;
  border-radius: 6px;
  overflow: hidden;
  border: 2px solid #e0e0e0;
  cursor: pointer; /* Курсор-указатель теперь на контейнере */
}
/* Картинка пропускает клики сквозь себя прямо на контейнер .wrapper */
#captcha-img {
  display: block;
  max-width: 100%;
  height: auto;
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: none; 
}
.controls {
  margin-top: 15px;
  display: flex;
  justify-content: normal;
  gap: 10px;
  align-items: center;
}
button {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.2s;
}
.btn-submit {
  background-color: #007bff;
  color: white;
}
.btn-submit:hover {
  background-color: #0056b3;
}
.btn-renew {
  background-color: #6c757d;
  color: white;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-renew:hover {
  background-color: #5a6268;
}

</style>

<style>
.click-marker {
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #dc3545;
  color: white;
  border-radius: 50%;
  font-size: 11px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  pointer-events: none; 
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
}
</style>